export default __webpack_public_path__ + "static/media/048-dog-tags-military.38557bc5.png";